import React from "react";
import { Box, Flex, Image, Text, Heading, Divider, Button } from "@chakra-ui/react";
import CustomCard from "../ui/card";
import { BsChevronRight } from "react-icons/bs";
import { formatDateToReadableString } from "../../utilities/others";

export default function OverviewUpdates() {
    const updates = [
        { id: '1', title: 'Matt Ibrahim', subTitle: 'Left a comment', createdAt: formatDateToReadableString('2021-06-28T07:48:34') },
        { id: '2', title: 'Uzo Grace', subTitle: 'Created a new repository', createdAt: formatDateToReadableString('2021-06-28T07:48:34')  },
        { id: '3', title: 'Ronk Leroy', subTitle: 'Left a comment', createdAt: formatDateToReadableString('2022-06-28T07:38:34') },
        { id: '4', title: 'Jessica Kine', subTitle: 'Created a new ticket', createdAt: formatDateToReadableString('2023-04-28T07:48:34')  },
    ]

    return (
        <CustomCard marginRight={'4'} className='overview-col-65' children={(
            <>
                <Heading as='h4' size='md' marginBottom={'8'}>
                    Updates
                </Heading>
                {updates.map((item) => (
                    <Flex key={item.id} justifyContent='space-between' alignItems='center' marginBottom={'6'}>
                        <Flex alignItems='center'>
                            <Box marginRight={'4'}>
                                <Image 
                                    boxSize='48px'
                                    objectFit='cover'
                                    src='https://bit.ly/dan-abramov'
                                    alt='Dan Abramov'
                                    borderRadius={'lg'}
                                />
                            </Box>
                            <Box>
                                <Text fontSize='sm' color={'blackAlpha.900'} fontWeight='semibold'>{item.title}</Text>
                                <Text color={'gray.500'} fontSize='sm'>{item.subTitle}</Text>
                            </Box>
                        </Flex>
                        <Box>
                            <Text color={'gray.500'} fontSize='sm'>{item.createdAt}</Text>
                        </Box>
                    </Flex>
                ))}
                <Divider />
                <Flex justifyContent={'flex-end'}>
                    <Button rightIcon={<BsChevronRight />} size='sm' colorScheme='blue' variant='ghost'>
                        View All
                    </Button>
                </Flex>
            </>
        )} />
    )
}